// Importation des styles CSS
import '../css/app.css';

// Importation de jQuery et assignation à window.jQuery et window.$
import $ from 'jquery';
window.jQuery = window.$ = $;

// Maintenant que jQuery est défini globalement, on peut importer les autres scripts
try {
  // Nous utilisons des importations dynamiques pour éviter les erreurs bloquantes
  // Importation des scripts dans le bon ordre
  require('/public/bizPage/assets/vendor/bootstrap/js/bootstrap.bundle.min.js');
  require('/public/bizPage/assets/vendor/jquery.easing/jquery.easing.min.js');
  require('/public/bizPage/assets/vendor/php-email-form/validate.js');
  require('/public/bizPage/assets/vendor/waypoints/jquery.waypoints.min.js');
  require('/public/bizPage/assets/vendor/counterup/counterup.min.js');
  require('/public/bizPage/assets/vendor/isotope-layout/isotope.pkgd.min.js');
  require('/public/bizPage/assets/vendor/venobox/venobox.min.js');
  require('/public/bizPage/assets/vendor/owl.carousel/owl.carousel.min.js');
  
  // AOS
  global.AOS = require('/public/bizPage/assets/vendor/aos/aos.js');
  
  // Script principal
  require('/public/bizPage/assets/js/main.js');
} catch (error) {
  console.warn('Erreur lors du chargement de certains scripts bizPage:', error.message);
  // L'application continuera de fonctionner même si certains scripts ne chargent pas
}

console.log('App.js chargé avec succès');